import type { PronounEnum } from '@bambi/api-client/schemas';
import type { SelectOption } from '@bambi/component-library/src/components/inputs/Select/SelectOption/SelectOption';

export const pronounOptions: SelectOption<PronounEnum>[] = [
  {
    label: 'He',
    value: 'he',
  },
  {
    label: 'She',
    value: 'she',
  },
  {
    label: 'They',
    value: 'they',
  },
];
